import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _invoke from 'lodash/invoke';
import cx from 'classnames';
import Arrow from '../SvgIcons/Arrow';
import componentUtils from '../../lib/componentUtils';

import './link.css';

const propTypes = {
  /** default size tries to inherit from page/parent context,
   *  but you can explicitly set it yourself using these props
   */
  size: PropTypes.oneOf([
    'inherit',
    'extra-small',
    'smaller',
    'small',
    'regular',
    'large',
    'larger',
    'semi-huge',
    'huge',
  ]),
  children: PropTypes.node,
  active: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  /** DEPRECATED */
  caret: PropTypes.bool,
  /** DEPRECATED */
  caretPosition: PropTypes.oneOf(['prefix', 'postfix']),
  arrow: PropTypes.bool,
  /** position of the arrow icon
   *  NOTE: arrowPosition should be used with arrow flag
   */
  arrowPosition: PropTypes.oneOf(['prefix', 'postfix']),
  target: PropTypes.string,
  subtle: PropTypes.bool,
  inline: PropTypes.bool,
  capitalize: PropTypes.bool,
  role: PropTypes.oneOf(['button', 'link']),
  color: PropTypes.oneOf(['default', 'red', 'black']),
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  selected: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  noUnderline: PropTypes.bool,
};

/**
 * @deprecated components/Link is deprecated, use components/LinkV2
 */
class Link extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { disabled } = this.props;

    if (disabled) {
      e.preventDefault();
      return;
    }

    _invoke(this.props, 'onClick', e, this.props);
  }

  render() {
    const {
      size,
      children,
      active,
      className,
      target,
      href,
      rel,
      caret,
      arrow,
      selected,
      inline,
      subtle,
      onClick,
      role,
      caretPosition,
      arrowPosition,
      capitalize,
      variant,
      color = 'default',
      noUnderline,
    } = this.props;

    const classes = cx('zola-ui', 'link', className, {
      prefix: caretPosition === 'prefix' || arrowPosition === 'prefix',
      'link-arrow': caret || arrow,
      'link-danger': color === 'red',
      'link-black': color === 'black',
      [size]: size !== 'inherit',
      [variant]: variant !== 'primary',
      active,
      selected,
      inline,
      subtle,
      capitalize,
      'no-underline': arrow || noUnderline,
    });

    const rest = componentUtils.getUnusedProps(propTypes, this.props);
    const hasChildren = componentUtils.hasChildren(children);

    const renderWithArrow = (element) => {
      if (!arrow && !caret) return element;

      return (
        <>
          {arrowPosition === 'prefix' && (
            <Arrow
              className="new-arrow"
              direction="left"
              showTitle={false}
              width={1.5}
              height={-1} // This is invalid but the component wants a height but we don't need it to maintain proportions with em
              unit="em"
            />
          )}
          {element}
          {arrowPosition === 'postfix' && (
            <Arrow
              className="new-arrow"
              flip="horizontal"
              showTitle={false}
              width={1.5}
              height={-1}
              unit="em"
            />
          )}
        </>
      );
    };

    if (role === 'button' && (onClick || rest.type === 'submit')) {
      return (
        <button type="button" {...rest} onClick={this.handleClick} className={classes}>
          {renderWithArrow(hasChildren && children)}
        </button>
      );
    }

    return (
      <a
        {...rest}
        href={href}
        onClick={this.handleClick}
        target={target}
        rel={rel}
        className={classes}
      >
        {renderWithArrow(hasChildren && children)}
      </a>
    );
  }
}

Link.defaultProps = {
  size: 'inherit',
  role: 'link',
  caretPosition: 'postfix',
  arrowPosition: 'postfix',
  variant: 'primary',
  href: '#',
};

Link.propTypes = propTypes;

export default Link;
